import { useTheme } from "@mui/material";
import {
	Activity,
	BarChart3,
	Bell,
	Calculator,
	IdCard,
	Settings,
	Shield,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import type { SettingsMenuItemType } from "web_myplann/More/Components/SettingsMenuItem";
import { device, NavigationTypes } from "web_myplann/Utils/device";

export const useSettingsMenuItems = () => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();

	const toolItems: SettingsMenuItemType[] = [
		{
			icon: BarChart3,
			label: t(Resources.Settings.Items.FinancialBalance),
			iconBg: theme.palette.green[100],
			iconColor: theme.palette.green[600],
			onClick: () =>
				navigate(AppRouting.MyPlann.Finances.Intro.path(), {
					state: { from: "profile" },
				}),
		},
		{
			icon: IdCard,
			label: t(Resources.Settings.Items.MyDocuments),
			iconBg: theme.palette.indigo[100],
			iconColor: theme.palette.indigo[600],
			onClick: () => navigate(AppRouting.MyPlann.Profile.Paperwork.path()),
		},
		{
			icon: Activity,
			label: t(Resources.Settings.Items.Activities),
			iconBg: theme.palette.orange[100],
			iconColor: theme.palette.orange[600],
			onClick: () => navigate(Routing.ActivitiesList.path()),
		},
		{
			icon: Calculator,
			label: t(Resources.Settings.Items.Calculators),
			iconBg: theme.palette.purple[100],
			iconColor: theme.palette.purple[600],
			onClick: () =>
				device.navigationRequest(NavigationTypes.CalculatorListScreen),
		},
	];

	const settingsItems: SettingsMenuItemType[] = [
		{
			icon: Settings,
			label: t(Resources.Settings.Items.Settings),
			iconBg: theme.palette.grey[100],
			iconColor: theme.palette.grey[600],
			onClick: () => navigate(AppRouting.MyPlann.Profile.Settings.path()),
		},
		{
			icon: Bell,
			label: t(Resources.Settings.Items.Notifications),
			iconBg: theme.palette.blue[100],
			iconColor: theme.palette.blue[600],
			onClick: () => navigate(AppRouting.MyPlann.Notifications.path()),
		},
		{
			icon: Shield,
			label: t(Resources.Settings.Items.Security),
			iconBg: theme.palette.green[100],
			iconColor: theme.palette.green[600],
			onClick: () => navigate(AppRouting.MyPlann.Profile.Security.path()),
		},
	];

	return { toolItems, settingsItems };
};
